export const REGISTRO_EXITOSO = 'REGISTRO_EXITOSO'; 
export const REGISTRO_ERROR = 'REGISTRO_ERROR';
export const OBTENER_USUARIO = 'OBTENER_USUARIO';
export const OBTENER_USUARIO_CHANGE_PASSWORD = 'OBTENER_USUARIO_CHANGE_PASSWORD';
export const LOGIN_EXITOSO = 'LOGIN_EXITOSO';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CERRAR_SESION = 'CERRAR_SESION';
export const LIMPIAR_ERROR = 'LIMPIAR_ERROR';
export const SET_LINKS_APP = 'SET_LINKS_APP';
export const SET_DICTIONARY = 'SET_DICTIONARY';
export const SET_GLOBALSETTINGS = 'SET_GLOBALSETTINGS';
export const MENSAJE_LICENCIA = 'MENSAJE_LICENCIA';

//Creados recientemente para Prueba Gratuita
export const SIGNUP_EXITOSO = 'SIGNUP_EXITOSO';
export const SIGNUP_ERROR = 'SIGNUP_ERROR';
export const CONFIRM_EMAIL_EXITOSO = 'CONFIRM_EMAIL_EXITOSO';
export const CONFIRM_EMAIL_ERROR = 'CONFIRM_EMAIL_ERROR';
export const SEND_EMAIL_TO_RECOVER_PASSWORD_EXITOSO = 'SEND_EMAIL_TO_RECOVER_PASSWORD_EXITOSO';
export const SEND_EMAIL_TO_RECOVER_PASSWORD_ERROR = 'SEND_EMAIL_TO_RECOVER_PASSWORD_ERROR';
export const OVERWRITE_PASSWORD_EXITOSO = 'OVERWRITE_PASSWORD_EXITOSO';
export const OVERWRITE_PASSWORD_ERROR = 'OVERWRITE_PASSWORD_ERROR';
export const VALIDATE_TOKEN_TO_OVERWRITE_PASSWORD_EXITOSO = 'VALIDATE_TOKEN_TO_OVERWRITE_PASSWORD_EXITOSO';
export const VALIDATE_TOKEN_TO_OVERWRITE_PASSWORD_ERROR = 'VALIDATE_TOKEN_TO_OVERWRITE_PASSWORD_ERROR';
export const NOT_SHOW_TUTO = 'NOT_SHOW_TUTO';

export const UPDATE_COLUMNS_PREFERENCES_USUARIO = 'UPDATE_COLUMNS_PREFERENCES_USUARIO';

export const UPDATE_AUTOBLOQUEO_USUARIO = 'UPDATE_AUTOBLOQUEO_USUARIO';

